import { Sparkles, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useRecommendations } from '@/hooks/useRecommendations';
import { useLanguage } from '@/i18n/LanguageContext';
import RoomCard from './RoomCard';

interface RecommendedRoomsProps {
  className?: string;
}

const RecommendedRooms = ({ className = '' }: RecommendedRoomsProps) => {
  const { recommendations, continueRooms, hasRecommendations, hasContinueRooms } = useRecommendations();
  const { t } = useLanguage();

  if (!hasRecommendations && !hasContinueRooms) return null;

  return (
    <section className={`space-y-6 ${className}`}>
      {/* Continue Where You Left Off */}
      {hasContinueRooms && (
        <div>
          <h2 className="text-xs uppercase tracking-widest text-muted-foreground/40 mb-4 flex items-center gap-2">
            <ArrowRight className="w-3 h-3" />
            {t('continue_journey') || 'Continue Your Journey'}
          </h2>
          <div className="grid sm:grid-cols-3 gap-3">
            {continueRooms.map((room, index) => (
              <RoomCard 
                key={room.id} 
                room={room} 
                animationDelay={index * 50}
              />
            ))}
          </div>
        </div>
      )}

      {/* Recommended For You */}
      {hasRecommendations && (
        <div>
          <h2 className="text-xs uppercase tracking-widest text-muted-foreground/40 mb-4 flex items-center gap-2">
            <Sparkles className="w-3 h-3" />
            {t('recommended_for_you') || 'Recommended For You'}
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {recommendations.map((room, index) => (
              <RoomCard 
                key={room.id} 
                room={room} 
                animationDelay={index * 50}
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default RecommendedRooms;
